<template>
  <el-dialog
    class="multi-language-edit-dialog"
    :class="{'fullscreen':fullscreen}"
    :title="dynamicTitle"
    :visible.sync="visible"
    :width="width"
    :before-close="handleBeforeClose"
    :close-on-click-modal="false"
    :fullscreen="fullscreen"
  >
    <!-- 多语言选项卡 -->
    <el-tabs
      v-if="enableMultiLanguage && languageList.length > 0"
      type="card"
      v-model="currentLanguageCode"
      @tab-click="handleLanguageTabClick"
      style="margin-bottom: 20px;"
    >
      <el-tab-pane
        v-for="(item, index) in languageList"
        :key="index"
        :label="item.name"
        :name="item.code"
      ></el-tab-pane>
    </el-tabs>

    <el-form
      ref="form"
      :model="formData"
      :rules="formRules"
      label-width="100px"
      :size="size"
      v-loading="loading"
      element-loading-text="等待接口数据返回中······"
    >
      <el-row v-for="(row, rowIdx) in groupedFormItems" :gutter="20" :key="'row-'+rowIdx">
        <el-col v-for="col in row" :span="(col.span || 1) * 8" :key="col.prop">
          <el-form-item
            :label="col.label"
            :prop="col.prop"
            :rules="col.rules"
          >
            <!-- 文本输入 -->
            <el-input v-if="!col.type || col.type==='text'" v-model="formData[col.prop]" :placeholder="col.placeholder || '请输入'+col.label" :disabled="col.disabled" />
            <!-- 多行文本 -->
            <el-input v-else-if="col.type==='textarea'" type="textarea" v-model="formData[col.prop]" :placeholder="col.placeholder || '请输入'+col.label" :disabled="col.disabled" />
            <!-- 数字输入 -->
            <el-input-number v-else-if="col.type==='number'" v-model="formData[col.prop]" :placeholder="col.placeholder || '请输入'+col.label" :disabled="col.disabled" :min="0" />
            <!-- 下拉选择 -->
            <el-select v-else-if="col.type==='select'" v-model="formData[col.prop]" :placeholder="col.placeholder || '请选择'+col.label" :disabled="col.disabled">
              <el-option v-for="(opt,index) in col.options" :key="index" :label="getOptionLabel(opt)" :value="getOptionValue(opt)" />
            </el-select>
            <!-- 多级下拉选择 -->
            <el-select v-else-if="col.type==='groupSelect'" v-model="formData[col.prop]" :placeholder="col.placeholder || '请选择'+col.label" :disabled="col.disabled">
              <el-option-group v-for="group in col.options" :key="group.label" :label="group.label">
                <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value" />
              </el-option-group>
            </el-select>
            <!-- 日期选择 -->
            <el-date-picker v-else-if="col.type==='date'" v-model="formData[col.prop]" type="date" :placeholder="col.placeholder || '请选择'+col.label" :disabled="col.disabled" />
            <!-- 开关 -->
            <el-switch v-else-if="col.type==='switch'" v-model="formData[col.prop]" :active-value="1" :inactive-value="0" :disabled="col.disabled" />
            <!-- 单图片上传 -->
            <UploadImage
              v-else-if="col.type==='image'"
              v-model="formData[col.prop]"
              :disabled="loading"
            />
            <!-- 多图片上传 -->
            <UploadImages
              v-else-if="col.type==='images'"
              v-model="formData[col.prop]"
              :disabled="loading"
              :limit="col.limit || 9"
              :max-size="col.maxSize || 1"
            />
            <!-- 文件上传 -->
            <UploadFile
              v-else-if="col.type==='file'"
              v-model="formData[col.prop]"
              :disabled="loading"
              :max-size="col.maxSize || 10"
              :accept-types="col.acceptTypes"
            />
            <!-- 视频上传 -->
            <UploadVideo
              v-else-if="col.type==='video'"
              v-model="formData[col.prop]"
              :disabled="loading"
              :max-size="col.maxSize || 100"
              :accept-types="col.acceptTypes"
            />
            <!-- HTML编辑器 -->
            <div v-else-if="col.type==='html'" class="html-editor-wrapper">
              <el-input
                type="textarea"
                v-model="formData[col.prop]"
                :placeholder="col.placeholder || '请输入HTML内容'"
                :rows="10"
                style="font-family: monospace;"
              />
              <div style="font-size: 12px; color: #999; margin-top: 5px;">
                提示：这是HTML内容编辑区域，支持HTML标签
              </div>
            </div>
            <!-- 富文本编辑器 -->
            <RichTextEditor v-else-if="col.type==='richText'" :keyWord="col.prop" :params="formData" v-model="formData[col.prop]" :disabled="loading" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import UploadImage from './UploadImage.vue';
import UploadImages from './UploadImages.vue';
import UploadFile from './UploadFile.vue';
import UploadVideo from './UploadVideo.vue';
import RichTextEditor from '@/components/richText.vue';
export default {
  name: 'MultiLanguageEditDialogDay',
  components: {
    UploadImage,
    UploadImages,
    UploadFile,
    UploadVideo,
    RichTextEditor
  },
  props: {
    title: { type: String, default: '编辑' },
    width: { type: String, default: '1000px' },
    size: { type: String, default: 'medium' },
    api: { type: String, default: '' },
    method: { type: String, default: 'post' },
    fullscreen: { type: Boolean, default: false },
    inline: { type: Boolean, default: false },
    // 详情接口配置
    detailApi: { type: String, default: '' },
    detailApiTemplate: { type: String, default: '' }, // 如 '/question/info/detail/{id}'
    // 多语言字段配置
    enableMultiLanguage: { type: Boolean, default: true }
  },
  data() {
    return {
      visible: false,
      loading: false,
      formData: {},
      columns: [],
      formRules: {},
      isEdit: false,
      customApi: null,
      detailUrl: '',
      languageList: [],
      currentLanguageCode: 'EN',
      originalData: {},
      localTitle: this.title, // 用本地变量保存
    };
  },
  computed: {
    filteredColumns() {
      return this.columns.filter(col => {
        if (this.isEdit && col.editHide) return false;
        if (!this.isEdit && col.addHide) return false;
        return true;
      });
    },
    groupedFormItems() {
      const cols = this.filteredColumns;
      const groups = [];
      let row = [];
      let rowSpan = 0;
      for (let i = 0; i < cols.length; i++) {
        const col = cols[i];
        const span = col.span || 1;
        if (rowSpan + span > 3) {
          groups.push(row);
          row = [];
          rowSpan = 0;
        }
        row.push(col);
        rowSpan += span;
        if (rowSpan === 3) {
          groups.push(row);
          row = [];
          rowSpan = 0;
        }
      }
      if (row.length) groups.push(row);
      return groups;
    },
    dynamicTitle() {
      return this.localTitle;
    }
  },
  watch: {
    formData: {
      handler(newVal) {
        // 数据变化监听
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.getLanguageList()
  },
  methods: {
    async getLanguageList() {
      try {
        const { data: res } = await this.$post('/language/list', {
          adminStatus: 1
        });
        
        if (res && res.data) {
          this.languageList = res.data;
          this.currentLanguageCode = (res.data[0] && res.data[0].code) || 'EN';
        }
      } catch (error) {
        console.error('获取语言列表失败:', error);
      }
    },
    async open(data = {}, columns = [], options = {},detailUrl = '') {
      this.visible = true;
      this.columns = columns;      
      this.detailUrl = detailUrl;
      this.originalData = { ...data };
      if(this.languageList.length === 0){
        await this.getLanguageList()
      }
      // 根据是否有数据判断是新增还是编辑
      this.isEdit = data && Object.keys(data).length > 0 && data.id;
      this.localTitle = this.isEdit ? '编辑' : '新增';
      if (options.title) this.localTitle = this.localTitle + ' - ' + options.title;
      
      // 配置选项
      if (options.api) this.api = options.api;
      if (options.method) this.method = options.method;
      if (options.customApi) this.customApi = options.customApi;
      
      // 多语言支持
      if (this.enableMultiLanguage) {
        // this.enableMultiLanguage = true;
        
        // 先设置初始数据
        this.formData = {};
        
        // 如果是编辑模式，获取默认语言的详情数据
        if (this.isEdit && data.id) {
          await this.loadLanguageData(this.currentLanguageCode,detailUrl);
        }
      } else {
        // 非多语言模式直接使用传入数据
        this.formData = {};
        Object.keys(data).forEach(key => {
          this.$set(this.formData, key, data[key]);
        });
      }
      
      // 处理日期字段，将 20250401 格式转换为 Date 对象
      this.processDateFieldsForDisplay();
      
      // 生成表单验证规则
      this.generateFormRules();
    },

    generateFormRules() {
      this.formRules = {};
      this.columns.forEach(col => {
        if (col.required) {
          this.formRules[col.prop] = [{ required: true, message: `请输入${col.label}`, trigger: 'blur' }];
        }
        if (col.rules) {
          this.formRules[col.prop] = col.rules;
        }
      });
    },

    async handleLanguageTabClick(tab) {
      this.currentLanguageCode = tab.name;
      
      // 如果是编辑模式且有原始数据，重新获取该语言的数据
      if (this.isEdit && this.originalData.id) {
        await this.loadLanguageData(tab.name,this.detailUrl);
      }
    },
    
    async loadLanguageData(languageCode,url = '') {        
      this.loading = true;
      try {
        // 构建详情接口URL
        let detailUrl = url;
        if (this.detailApi) {
          detailUrl = `${this.detailApi}/${this.originalData.id}`;
        }else if(this.detailApiTemplate){
          detailUrl = this.detailApiTemplate.replace('{id}', this.originalData.id);
        }
        
        if (!detailUrl) {
          console.warn('未配置详情接口');
          // 如果没有配置详情接口，直接使用原始数据
          this.formData = {};
          Object.keys(this.originalData).forEach(key => {
            this.$set(this.formData, key, this.originalData[key]);
          });
          return;
        }

        // 调用详情接口获取指定语言的数据
        const { data: res } = await this.$get(detailUrl, {
          headers: {
            'Language-Code': languageCode
          }
        });
        
        if (res && res.data) {
          // 合并原始数据和详情数据，确保所有字段都存在
          const updatedData = {
            ...this.originalData, // 先使用原始数据作为基础
            ...res.data           // 然后用详情数据覆盖
          };
          
          // 使用Vue.set确保响应式更新
          Object.keys(updatedData).forEach(key => {
            this.$set(this.formData, key, updatedData[key]);
          });
          
          // 强制更新表单
          this.$nextTick(() => {
            if (this.$refs.form) {
              this.$refs.form.clearValidate();
            }
            // 处理日期字段，将 20250401 格式转换为 Date 对象用于显示
            this.processDateFieldsForDisplay();
          });
        } else {
          // 如果接口没有返回数据，使用原始数据
          console.warn('详情接口未返回数据，使用原始数据');
          this.formData = {};
          // Object.keys(this.originalData).forEach(key => {
          //   this.$set(this.formData, key, this.originalData[key]);
          // });
          
          // 处理日期字段
          this.$nextTick(() => {
            this.processDateFieldsForDisplay();
          });
        }
      } catch (error) {
        console.error('加载语言数据失败:', error);
        // 出错时使用原始数据
        this.formData = {};
        // Object.keys(this.originalData).forEach(key => {
        //   this.$set(this.formData, key, this.originalData[key]);
        // });
        
        // 处理日期字段
        this.$nextTick(() => {
          this.processDateFieldsForDisplay();
        });
        
        this.$message.error('加载语言数据失败');
      } finally {
        this.loading = false;
      }
    },

    handleClose() {
      this.visible = false;
      // 重置数据
      this.formData = {};
      this.columns = [];
      this.localTitle='';
      this.formRules = {};
      this.originalData = {};

      this.currentLanguageCode = 'EN';
      this.$emit('close');
    },

    handleBeforeClose(done) {
      this.handleClose();
      done();
    },

    async handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        this.loading = true;
        try {
          let res;
          
          // 处理日期字段，将日期对象转换为 20250401 格式
          const processedFormData = this.processDateFields(this.formData);
          
          // 如果有自定义API函数，优先使用
          if (this.customApi && typeof this.customApi === 'function') {
            // 传递当前语言代码给父组件的自定义API
            res = await this.customApi(processedFormData, this.currentLanguageCode);
          } else {
            // 使用传统的API调用方式
            const headers = this.enableMultiLanguage ? { 'Language-Code': this.currentLanguageCode } : {};
            
            if (this.method === 'post') {
              res = await this.$post(this.api, processedFormData, { headers });
            } else if (this.method === 'put') {
              res = await this.$put(this.api, processedFormData, { headers });
            }
          }
          
          this.$message.success('保存成功');
          this.$emit('success', res);

          if(this.isEdit){
            await this.loadLanguageData(this.currentLanguageCode,this.detailUrl)
          }else{
            this.handleClose();
          }
        } catch (e) {
          console.error('保存失败:', e);
          this.$message.error(e.message || '保存失败');
        } finally {
          this.loading = false;
        }
      });
    },

    getOptionKey(opt) {
      return opt.key;
    },

    getOptionLabel(opt) {
      return opt.name || opt.label || opt.title || opt.text || opt;
    },

    getOptionValue(opt) {
      return opt.id || opt.value || opt.key || opt;
    },

    // 处理日期字段，将日期对象转换为 20250401 格式
    processDateFields(formData) {
      const processedData = { ...formData };
      
      // 遍历列配置，找到日期类型的字段
      this.columns.forEach(col => {
        if (col.type === 'date' && processedData[col.prop]) {
          const dateValue = processedData[col.prop];
          
          // 如果是 Date 对象，转换为 20250401 格式
          if (dateValue instanceof Date) {
            const year = dateValue.getFullYear();
            const month = String(dateValue.getMonth() + 1).padStart(2, '0');
            const day = String(dateValue.getDate()).padStart(2, '0');
            processedData[col.prop] = `${year}${month}${day}`;
          }
          // 如果已经是字符串格式，保持原样
          else if (typeof dateValue === 'string') {
            // 检查是否是标准日期格式 (YYYY-MM-DD)
            if (/^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
              processedData[col.prop] = dateValue.replace(/-/g, '');
            }
          }
        }
      });
      
      return processedData;
    },

    // 处理日期字段，将 20250401 格式转换为 Date 对象用于显示
    processDateFieldsForDisplay() {
      // 遍历列配置，找到日期类型的字段
      this.columns.forEach(col => {
        if (col.type === 'date' && this.formData[col.prop]) {
          const dateValue = this.formData[col.prop];
          
          let dateStr = '';
          
          // 处理字符串类型
          if (typeof dateValue === 'string' && /^\d{8}$/.test(dateValue)) {
            dateStr = dateValue;
          }
          // 处理数字类型
          else if (typeof dateValue === 'number') {
            dateStr = dateValue.toString();
            if (!/^\d{8}$/.test(dateStr)) {
              return;
            }
          } else {
            return;
          }
          
          // 转换为 Date 对象
          const year = parseInt(dateStr.substring(0, 4));
          const month = parseInt(dateStr.substring(4, 6)) - 1; // 月份从0开始
          const day = parseInt(dateStr.substring(6, 8));
          const newDate = new Date(year, month, day);
          this.$set(this.formData, col.prop, newDate);
        }
      });
    },
  }
};
</script>

<style scoped lang="scss">
.multi-language-edit-dialog{

  :deep(.el-dialog){
    margin:0 auto !important;
    max-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .el-dialog__header,.el-dialog__footer{
      flex:none;
      width: 100%;
      box-sizing: border-box;
    }
    .el-dialog__body{
      flex: 1 1 auto;
      overflow-y: auto;
      width: 100%;
      box-sizing: border-box;
    }
  }
  &.fullscreen{
      :deep(.el-dialog){
        height: 100vh;
        width: 100vw;
      }
  }
}
</style> 